import { sample } from './lib/math'
import { HSL } from './types'

// export const _palette: RGB[] = [
//   // [0, 200, 0],
//   [255, 0, 0],
//   [0, 0, 255],
//   [255, 255, 255],
//   // [0, 0, 128],
//   // [252, 2, 160],
//   [0, 0, 0],
//   [255, 255, 0]
//   // [252, 172, 1],
//   // [0, 216, 254]
// ]

// export const palette: RGB[] = [
//   [228, 127, 61],
//   [80, 130, 65],
//   [124, 45, 29],
//   [224, 79, 58],
//   [27, 70, 168],
//   [130, 174, 249],
//   [168, 54, 47],
//   [235, 74, 104],
//   [0, 0, 0]
// ]

// const fullPalette: HSL[] = [
//   [0, 0, 0],
//   [255, 255, 255],
//   [250, 10, 10],
//   [10, 10, 250],
//   [10, 250, 10],
//   [250, 10, 250],
//   [237, 96, 52],
//   [132, 192, 230],
//   [252, 241, 98],
//   [180, 57, 43],
//   [112, 124, 143],
//   [15, 34, 150],
//   [210, 100, 63],
//   [87, 148, 93],
//   [30, 30, 30],
//   [145, 145, 145],
//   [100, 100, 100],
//   [227, 144, 161],
//   [228, 234, 76],
//   [150, 173, 138],
//   [202, 84, 61],
//   [137, 153, 130],
//   [210, 201, 153],
//   [196, 194, 189],
//   [23, 53, 178],
//   [29, 64, 203]
// ]

// let palette = samplePalette(fullPalette)
let palette = newPalette()
function newPalette(): HSL[] {
  // return Math.random() > 0.5 ?
  return [
    [0, 255, 180],
    [120, 20, 180],
    [120, 0, 0]
  ]
  // return randomPalette() // : samplePalette(fullPalette)
}

// setInterval(() => {
//   // const index = Math.round(Math.random() * (palette.length - 1))
//   palette.push(randomColour())

// }, 5000)

export function getCurrentPalette(): HSL[] {
  return palette
}

// function createRandomOrderPalette(input: RGB[]): RGB[] {
//   const result: RGB[] = []
//   for (let i = 0; i < 10; i++) {
//     result.push(...shuffle(input))
//   }
//   return result
// }

function randomColour(minSaturation = 0, minLightness = 0): HSL {
  const colour: number[] = []
  // for (let channel = 0; channel < 3; channel++) {
  //   colour[channel] = Math.round(Math.random() * 255)
  // }
  colour[0] = Math.round(Math.random() * 255)
  colour[1] = Math.min(
    255,
    Math.round(Math.random() * 255 * (1 - minSaturation)) + minSaturation * 255
  )
  colour[2] = Math.min(
    255,
    Math.round(Math.random() * 255 * (1 - minLightness)) + minLightness * 255
  )
  return colour as HSL
}

function randomPalette(): HSL[] {
  const colourCount = Math.round(Math.random() * 4) + 2
  const result: HSL[] = []

  for (let i = 0; i < colourCount; i++) {
    result.push(randomColour(0.5, 0))
  }
  return result
}

function samplePalette(input: HSL[]): HSL[] {
  const selection: HSL[] = []
  const result: HSL[] = []
  const size = Math.round(Math.random() * 7) + 3

  for (let i = 0; i < size; i++) {
    selection.push(sample(input) as HSL)
  }
  if (Math.random() > 0.5) {
    return selection
  }

  for (let i = 0; i < Math.round(Math.random() * 7) + 3; i++) {
    result.push(sample(selection)!)
  }
  return result
}

export function mutatePalette(): void {
  const randomIndex = Math.round(Math.random() * palette.length)

  if (Math.random() > 0.5 && palette.length > 3) {
    palette.splice(randomIndex, 1)
  } else {
    palette.splice(randomIndex, 0, randomColour(0.5, 0))
  }
}
